import React from 'react'

function NavButton(props) {
  const { t, setEntrepreneurList, entrepreneurList } = props
  const buttons = ['buttonAll', 'buttonFavorites']

  const handleClick = (label) => {
    setEntrepreneurList(label)
  }

  const styles = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      marginBottom: '10px',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.6)'
    },
    list: {
      display: 'flex',
      flexDirection: 'row', // Default to horizontal layout
      listStyleType: 'none',
      padding: 0,
      margin: 0
    },
    listItem: {
      display: 'inline',
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: '8px',
      textAlign: 'center'
    },
    activeListItem: {
      backgroundColor: '#44c0cc',
      color: '#FFFFFF'
    },
    // Mobile-specific styles
    '@media (max-width: 600px)': {
      list: {
        flexDirection: 'column', // Stack items vertically on smaller screens
        alignItems: 'center'
      },
      listItem: {
        width: '100%', // Make items full-width for easier tapping
        marginBottom: '10px'
      }
    }
  }

  return (
    <div style={styles.container}>
      <ul style={styles.list}>
        {buttons.map((el, index) => (
          <li
            key={index}
            onClick={() => handleClick(el)}
            style={{
              ...styles.listItem,
              ...(entrepreneurList === el ? styles.activeListItem : {})
            }}
          >
            <b>{t(`employer.lightEntrepreneurs.${el}`)}</b>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default NavButton
